import { render, staticRenderFns } from "./DocumentProofAddress.vue?vue&type=template&id=772c0732&scoped=true&"
import script from "./DocumentProofAddress.vue?vue&type=script&lang=js&"
export * from "./DocumentProofAddress.vue?vue&type=script&lang=js&"
import style0 from "./DocumentProofAddress.vue?vue&type=style&index=0&id=772c0732&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772c0732",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('772c0732')) {
      api.createRecord('772c0732', component.options)
    } else {
      api.reload('772c0732', component.options)
    }
    module.hot.accept("./DocumentProofAddress.vue?vue&type=template&id=772c0732&scoped=true&", function () {
      api.rerender('772c0732', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/LMSGiframe/components/DocumentProofAddress.vue"
export default component.exports